import {observer} from "mobx-react";
import ErrorStore from "../../stores/error.store";
import React, {useEffect, useState} from 'react'
import {bool} from "prop-types";
import {makeAutoObservable, makeObservable, observable} from "mobx";
import {FallbackPage} from "./FallbackPage";


export const AllErrorsBoundary = observer(
    class extends React.Component {
        constructor(props) {
            super(props);
            this.state = {hasError: false, error: ""};
        }

        static getDerivedStateFromError(error) {
            // Обновить состояние с тем, чтобы следующий рендер показал запасной UI.
            return {hasError: true, error};
        }

        componentDidCatch(error, errorInfo) {
            // Можно также сохранить информацию об ошибке в соответствующую службу журнала ошибок

            if (error) ErrorStore.setError(error, errorInfo, "react")

        }

        render() {
            if (this.state.hasError && this.state.error || ErrorStore.error) {
                // Можно отрендерить запасной UI произвольного вида
                return <FallbackPage/>;
            }

            return this.props.children;
        }
    }
)

export function functionBoundary(callback, type = 'function') {
    return function () {
        try {
            callback()
        } catch (e) {
            ErrorStore.setError(e, "", type)
        }
    }
}